import { setupI18n } from '@lingui/core';
import { createIsomorphicFn } from '@tanstack/react-start';

import { dynamicActivate } from '.';
import { i18n } from '../i18n';
import { getLocaleFromRequest } from '../server';

// SSR must never activate the browser singleton: overlapping requests have different locales.
// The client keeps its existing instance, including the locale restored by native boot/hydration.
export const getActiveI18n = createIsomorphicFn()
  .client(() => Promise.resolve(i18n))
  .server(async () => {
    const locale = getLocaleFromRequest();
    const requestI18n = setupI18n({});
    await dynamicActivate(requestI18n, locale);
    return requestI18n;
  });
